import { getStates, getCountries } from 'country-state-picker';

export const makeStateOption = (countryCode) => {
  const states = getStates(countryCode).map((key, idx) => {
    const value = key.split(' ')[0] || idx;
    return {
      label: value, id: `${value}${idx}`, value, key: `${value}${idx}`,
    };
  });
  return states;
};

export const countriesOptions = getCountries().map(({ name }) => ({ label: name, id: name, value: name }));
